// @ts-check
import { Howl } from "howler";
import { baseUrl } from "../constants";
import resourceTree from "../res/**/*.json";

// Build resource cache
const resources = Object.keys(resourceTree).reduce((resources, type) => {
    const dir = resourceTree[type];
    Object.keys(dir).forEach(name => (resources[[type, name].join("/")] = dir[name]));
    return resources;
}, {});

// Helper
function blobToBase64(blob) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

/**
 * Resource
 */
export class Resource {
    constructor(type, id, options = {}) {
        this.id = id;
        this.type = type;
        this.options = options;
        this.complete = false;
    }
}

/**
 * Image Resource
 */
export class ImageResouce extends Resource {
    constructor(id) {
        super("image", id);
    }

    load() {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = evt => reject("Image not found: " + evt.target.imageId);
            img.src = this.id.startsWith("http") ? this.id : `${baseUrl}/res/${this.id}.png`;
        });
    }
}

/**
 * Sound Resource
 */
export class SoundResouce extends Resource {
    constructor(id, options = {}) {
        super("sound", id, options);
    }

    load() {
        const url = `${baseUrl}/res/${this.id}.mp3`;
        if (true) {
            return new Promise(resolve => {
                const howl = new Howl({ ...this.options, src: url });
                howl.on("load", () => resolve(howl));
                howl.load();
            });
        } else {
            return fetch(url)
                .then(res => res.blob())
                .then(blobToBase64)
                .then(src => new Howl({ ...this.options, src }));
        }
    }
}

/**
 * Resource Manager
 */
export const ResourceManager = {
    // Attributes
    resources: {},
    loadingState: 0,

    // Query text resource
    resource(resourceId) {
        return resources[resourceId];
    },

    // Query image resource
    image(name) {
        const id = `gfx/${name}`;
        this.resources[id] = this.resources[id] || new ImageResouce(id);
        return this.resources[id];
    },

    // Query sound resource
    sound(name, options = {}) {
        const id = `sound/${name}`;
        this.resources[id] = this.resources[id] || new SoundResouce(id, options);
        return this.resources[id];
    },

    /**
     *
     */
    load() {
        this.loadingState = 0;
        const resources = Object.values(this.resources).filter(res => !res.loaded);
        return Promise.all(
            resources.map(async res => {
                // Load resource
                res.value = await res.load();
                res.loaded = true;

                // Recalc loading state
                const loaded = resources.map(res => res.loaded);
                this.loadingState = loaded.filter(Boolean).length / (loaded.length || 1);
            })
        );
    },

    // Pause resources
    pause() {
        Object.values(this.resources).forEach(res => {
            if (res.type == "sound" && res.value && res.value.playing() && res.value.loop()) {
                res._resume = true;
                res.value.stop();
            }
        });
    },

    // Resume resources
    resume() {
        Object.values(this.resources).forEach(res => {
            if (res.type == "sound" && res._resume) {
                delete res._resume;
                res.value.play();
            }
        });
    }
};
